import ProfessionalAuthentication from "../ProfessionalAuthentication"
import { configureStore } from "@reduxjs/toolkit"
import PokalApiToaster from "../PokalApiToaster"
import ProfessionalDashboard from "../ProfessionalDashboard"
import ContextMenu from "../ContextMenu"
import Notification from "../Notification"
import Onboarding from "../Onboarding"
import AccountSettings from "../AccountSettings"
import AnalysisMessageReady from "../AnalysisMessageReady"

export const StoreState = {
    professionalAuthentication: ProfessionalAuthentication,
    pokalApiToaster: PokalApiToaster,
    professionalDashboard: ProfessionalDashboard,
    contextMenu: ContextMenu,
    notification: Notification,
    onboarding: Onboarding,
    accountSettings: AccountSettings,
    analysisMessageReady: AnalysisMessageReady
}

const store = configureStore({
    reducer: StoreState
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
